import Plyr from 'plyr';
import iubendaNoticeCaller from "./iubenda-notice.js";

let iubendaNotice = iubendaNoticeCaller(i18n.iubendaNoticeVideo);

function initPlyr(videoParent) {
    new Plyr(videoParent, {
        controls: [
            'play-large',
            'play',
            'progress',
            'current-time',
            'mute',
            'volume',
            'fullscreen'
        ],
        iconUrl: m6e.spriteUrl,
        iconPrefix: 'icon-'
    });
}

function fixWrapperForPlyr(element) {
    // Plyr funziona esclusivamente se il contenitore dell'<iframe> è un div
    if (element.parentElement.tagName !== "DIV") {
        let old = element.parentElement;
        let div = document.createElement("div");
        div.classList.add("c-video");

        old.parentElement.insertBefore(div, old);
        div.appendChild(element);

        old.remove();
    }
}

export default class VideoComponent {
    init() {
        /**
         * Video normali, NON bloccati da Iubenda.
         */
        document.querySelectorAll('iframe[src*="youtu"], iframe[src*="vimeo"]').forEach((element) => {
            fixWrapperForPlyr(element);
            initPlyr(element.parentElement);
        });

        /**
         * Video bloccati da Iubenda.
         *
         * Sembra che Iubenda abbia problemi a sbloccare i video successivi al primo,
         * se nel frattempo sto eseguendo Plyr sul primo video. Quindi, procedo raccogliendo
         * gli iframe in un array man mano che Iubenda li sblocca. Quando Iubenda ha finito
         * di sbloccare tutti gli iframe, li passo a Plyr.
         */
        let iubendaLockedIframes = document.querySelectorAll('iframe[suppressedsrc*="youtu"], iframe[suppressedsrc*="vimeo"]');
        let iubendaReadyIframes = [];

        iubendaLockedIframes.forEach((element) => {
            fixWrapperForPlyr(element);
            iubendaNotice.appendBefore(element);
            iubendaNotice.observeMutation(element.parentElement, (mutation) => {
                // Attenzione: qua devo inserire mutation.target e non element. Perché? Boh.
                iubendaReadyIframes.push(mutation.target);

                if (iubendaReadyIframes.length === iubendaLockedIframes.length) {
                    // Il numero di iframe nella pagina è uguale a quelli
                    // sbloccati da Iubenda, quindi posso procedere con Plyr.
                    iubendaReadyIframes.forEach(element => {
                        initPlyr(element);
                    });
                }
            });
        });

        /**
         * Widget video di Elementor.
         *
         * Qua è diverso, perché Iubenda blocca il Javascript di Elementor, non gli iframe.
         */
        document.querySelectorAll(".elementor-video").forEach((element) => {
            iubendaNotice.appendInside(element);
            iubendaNotice.observeMutation(element.parentElement, (mutation) => {
                initPlyr(mutation.target);
            });
        });
    }
};
